const C = {
  name: "TooltipFilled",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1 12C1 5.92772 5.92772 1 12 1C18.0723 1 23 5.92772 23 12C23 18.0723 18.0723 23 12 23C5.92772 23 1 18.0723 1 12ZM11 8H13C13.5477 8 14 8.45228 14 9V9.56C14 9.99304 13.7226 10.3767 13.3172 10.5102L13.3101 10.5125L13.0493 10.6028C11.8191 11.0117 11 12.1658 11 13.45V14.01H13V13.45C13 13.017 13.2774 12.6333 13.6828 12.4998L13.6899 12.4975L13.9507 12.4072C15.1809 11.9984 16 10.8442 16 9.56V9C16 7.34772 14.6523 6 13 6H11C9.34772 6 8 7.34772 8 9V10H10V9C10 8.45228 10.4523 8 11 8ZM12 18.25C12.6904 18.25 13.25 17.6904 13.25 17C13.25 16.3096 12.6904 15.75 12 15.75C11.3096 15.75 10.75 16.3096 10.75 17C10.75 17.6904 11.3096 18.25 12 18.25Z" fill="currentColor"/>
</svg>
  `
};
export {
  C as TooltipFilled
};
